import { NotificationsComponent } from './notifications/notifications.component';

export const containers = [NotificationsComponent];

export const entryContainers = [NotificationsComponent];

export * from './notifications/notifications.component';
